'use client';
import { useState } from 'react';

const H = "Rajdhani, sans-serif";
const B = "'Nunito Sans', sans-serif";

const ARTICLES = [
  {
    id: 1,
    title: 'Nordic Pro X9: Neste generasjon industrimaskin',
    date: '28. februar 2026',
    category: 'Ny maskin',
    description: 'Vi presenterer Nordic Pro X9 — vår kraftigste maskin til dags dato. Med 40% mer ytelse, ny AI-styring og redusert energiforbruk setter X9 en ny standard for industrielle maskiner i Norge.',
  },
  {
    id: 2,
    title: 'Programvareoppdatering v4.2.1 — hva er nytt',
    date: '20. februar 2026',
    category: 'Programvare',
    description: 'Den nyeste oppdateringen bringer forbedret feildiagnostikk, raskere oppstartstid og ny integrasjon med SebNorge Dashboard. Les om alle endringene i denne versjonen.',
  },
  {
    id: 3,
    title: 'SebNorge utvider til 5 nye europeiske markeder',
    date: '10. februar 2026',
    category: 'Selskapet',
    description: 'SebNorge er nå tilgjengelig i Polen, Tsjekkia, Østerrike, Sveits og Nederland. Med denne ekspansjonen betjener vi nå 38 land og over 15 000 industrielle maskiner globalt.',
  },
  {
    id: 4,
    title: 'Bærekraft 2025: SebNorge reduserer CO₂-avtrykk med 32%',
    date: '1. februar 2026',
    category: 'Bærekraft',
    description: 'Vår årsrapport for bærekraft viser at SebNorge har redusert sitt totale CO₂-avtrykk med 32% sammenlignet med 2024. Les om tiltakene som har gjort dette mulig.',
  },
];

export default function BlogInteractive() {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [emailToggle, setEmailToggle] = useState(true);
  const [smsToggle, setSmsToggle] = useState(true);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    setSubscribed(true);
  };

  return (
    <div style={{ background: '#0A0A0A', minHeight: '100vh', paddingTop: '52px' }}>
      {/* Hero */}
      <div style={{ borderBottom: '1px solid #1A1A1A', padding: '64px 0 48px' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
          <p style={{ fontFamily: B, fontWeight: 300, fontSize: '0.7rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.3)', marginBottom: '12px' }}>SebNorge</p>
          <h1 style={{ fontFamily: H, fontWeight: 700, fontSize: 'clamp(2rem, 5vw, 3.5rem)', letterSpacing: '0.06em', textTransform: 'uppercase', color: 'white', margin: '0 0 16px' }}>Blogg & Nyheter</h1>
          <p style={{ fontFamily: B, fontWeight: 300, fontSize: '1rem', color: 'rgba(255,255,255,0.45)', maxWidth: '560px' }}>Siste nyheter om maskiner, programvareoppdateringer, bransjenyheter og kunngjøringer fra SebNorge.</p>
        </div>
      </div>

      {/* Articles Grid */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '64px 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1px', background: '#1A1A1A' }}>
          {ARTICLES.map(article => (
            <div key={article.id} style={{ background: '#0A0A0A', padding: '32px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {/* Cover placeholder */}
              <div style={{ height: '160px', background: 'linear-gradient(135deg, #111 0%, #1A1A1A 100%)', border: '1px solid #2A2A2A', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontFamily: H, fontWeight: 700, fontSize: '0.6rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.15)' }}>SebNorge</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontFamily: H, fontWeight: 700, fontSize: '0.55rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.4)', border: '1px solid #2A2A2A', padding: '3px 8px' }}>{article.category}</span>
                <span style={{ fontFamily: B, fontWeight: 300, fontSize: '0.75rem', color: 'rgba(255,255,255,0.3)' }}>{article.date}</span>
              </div>
              <h2 style={{ fontFamily: H, fontWeight: 700, fontSize: '1.1rem', letterSpacing: '0.04em', textTransform: 'uppercase', color: 'white', margin: 0, lineHeight: 1.3 }}>{article.title}</h2>
              <p style={{ fontFamily: B, fontWeight: 300, fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.6, flex: 1, margin: 0 }}>{article.description}</p>
              <button
                style={{ background: 'transparent', color: 'rgba(255,255,255,0.6)', border: '1px solid #2A2A2A', fontFamily: H, fontWeight: 600, fontSize: '0.6rem', letterSpacing: '0.18em', textTransform: 'uppercase', padding: '8px 16px', cursor: 'pointer', alignSelf: 'flex-start' }}
                onClick={() => alert('Artikkel kommer snart...')}
              >Les mer →</button>
            </div>
          ))}
        </div>
      </div>

      {/* Newsletter */}
      <div style={{ borderTop: '1px solid #1A1A1A', background: '#080808', padding: '64px 24px' }}>
        <div style={{ maxWidth: '640px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontFamily: H, fontWeight: 700, fontSize: '1.8rem', letterSpacing: '0.08em', textTransform: 'uppercase', color: 'white', marginBottom: '12px' }}>Abonner på nyhetsbrevet</h2>
          <p style={{ fontFamily: B, fontWeight: 300, fontSize: '0.9rem', color: 'rgba(255,255,255,0.4)', marginBottom: '32px' }}>Motta nyheter om maskiner, programvareoppdateringer og tilbud direkte i innboksen din.</p>
          {subscribed ? (
            <div style={{ border: '1px solid #22c55e', padding: '20px', color: '#22c55e', fontFamily: H, fontWeight: 700, fontSize: '0.8rem', letterSpacing: '0.15em', textTransform: 'uppercase' }}>✓ Du er nå abonnent!</div>
          ) : (
            <form onSubmit={handleSubscribe}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }} className="newsletter-inputs-grid">
                <input
                  type="email" required value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="E-postadresse"
                  style={{ background: '#111', border: '1px solid #2A2A2A', color: 'white', fontFamily: B, fontWeight: 300, fontSize: '0.85rem', padding: '12px 16px', outline: 'none' }}
                />
                <input
                  type="tel" value={phone} onChange={e => setPhone(e.target.value)}
                  placeholder="+47 000 00 000 (valgfritt)"
                  style={{ background: '#111', border: '1px solid #2A2A2A', color: 'white', fontFamily: B, fontWeight: 300, fontSize: '0.85rem', padding: '12px 16px', outline: 'none' }}
                />
              </div>
              <div style={{ display: 'flex', gap: '24px', justifyContent: 'center', marginBottom: '20px', flexWrap: 'wrap' }}>
                {[{ label: 'E-post varsler', val: emailToggle, set: setEmailToggle }, { label: 'SMS varsler', val: smsToggle, set: setSmsToggle }].map(t => (
                  <label key={t.label} style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                    <button type="button" onClick={() => t.set(!t.val)} style={{ width: '40px', height: '22px', background: t.val ? '#22c55e' : '#2A2A2A', border: 'none', cursor: 'pointer', position: 'relative', transition: 'background 0.2s' }}>
                      <span style={{ position: 'absolute', top: '3px', left: t.val ? '20px' : '3px', width: '16px', height: '16px', background: 'white', transition: 'left 0.2s' }} />
                    </button>
                    <span style={{ fontFamily: B, fontWeight: 300, fontSize: '0.8rem', color: 'rgba(255,255,255,0.6)' }}>{t.label}</span>
                  </label>
                ))}
              </div>
              <button type="submit" style={{ background: 'white', color: '#0A0A0A', border: 'none', fontFamily: H, fontWeight: 700, fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase', padding: '14px 40px', cursor: 'pointer', width: '100%' }}>Abonner nå</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
